import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

export default function LoginAsesor() {
  const [correo, setCorreo] = useState("");
  const [contrasena, setContrasena] = useState("");


const navigate = useNavigate();
const handleSubmit = async () => {
  try {
    const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        correo: correo,
        contrasena: contrasena,
      }),
    });

    const result = await response.json();

    if (response.ok) {
      localStorage.setItem("token", result.token);
      //console.log("Token guardado:", result.token);
      Swal.fire({
      position: "top-end",
      icon: "success",
      title: "Bienvenido Ricardo!",
      showConfirmButton: false,
      timer: 2500
    });
      navigate("/citasclientes");
    } else {
      alert("Error: " + result.error);
    }
  } catch (error) {
    console.error("Error al enviar los datos", error);
    alert("Error en la conexión");
  }
};

  return (
    <div style={styles.contenedor}>
      <div style={styles.tarjeta}>
        <div style={styles.encabezado}>
          <div style={styles.titulo}>Bienvenido Asesor</div>
          <div style={styles.subtitulo}>Inicia sesión para continuar</div>
        </div>

        <input type="email" placeholder="Correo electrónico" value={correo} onChange={(e) => setCorreo(e.target.value)} style={styles.input}/>
        <input type="password" placeholder="Contraseña" value={contrasena} onChange={(e) => setContrasena(e.target.value)} style={styles.input}/>

        <button onClick={handleSubmit} style={styles.boton}>Iniciar sesión</button>
        </div>
      </div>
  );
}

  const styles = {
    contenedor: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f1f4f9',
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
    },
    tarjeta: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '40px',
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    },
    encabezado: {
      textAlign: 'center',
      marginBottom: '30px',
      color: '#0c1f4d',
    },
    titulo: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '5px',
    },
    subtitulo: {
      fontSize: '14px',
      color: '#666',
    },
    input: {
      width: '100%',
      padding: '12px',
      marginBottom: '20px',
      borderRadius: '6px',
      border: '1px solid #ccc',
      fontSize: '14px',
    },
    boton: {
      width: '100%',
      padding: '12px',
      backgroundColor: '#0c1f4d',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
    },
    registro: {
      marginTop: '20px',
      textAlign: 'center',
      fontSize: '13px',
      color: '#666',
    },
    link: {
      color: '#0c1f4d',
      fontWeight: 'bold',
      cursor: 'pointer',
    }
  };
